// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">Benefits for Servicemembers with <span> Private Education Loans</span></h1> ";
// Exports
export default code;